import React, { FunctionComponent } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import styled, { css } from "styled-components";
import { device, sizeConstants } from "../../../globalStyles";
import { topNavHeightPx } from "../../../View/Products/Constants/StyleConstants";

interface IColSegInfo {
    dotColor: string;
    title: string | JSX.Element;
    text: string;
}

interface IColSegInfoSC {
    dotColor: string;
}

export const ReportOuterWrapper = styled("section")`
  height: 100%;
  overflow: auto;
  background-color: #f7f9fb;
  font-size: 13px;
  color: black;
  position: relative;
  padding-top: ${topNavHeightPx}px;
`;

export const ReportInnerWrapper = styled("div")`
  width: 100%;
  margin: 0 auto;
`;

export const ReportScrollableSection = styled.div`
  margin: 0 auto;
  padding: ${sizeConstants.mobileLRContainerPadding}px;
  max-width: ${sizeConstants.containerMaxWidth}px;

  ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ${device.containerMaxWidth} {
    padding: ${sizeConstants.mobileLRContainerPadding}px 0;
  }
`;

export const ReportDataWrapper = styled.div`
  width: 100%;

  &:last-child:nth-child(2n-1) {
    grid-column: span 2;
  }

  ${device.desktop} {
    &:last-child:nth-child(2n-1) {
      grid-column: span 1;
    }
  }
`;

export const ReportDataWrapperHead = styled("div")`
  width: 100%;
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReportHeaderInnerContainer = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

export const ReportDataWrapperBody = styled(ScrollAnimation)`
  border-radius: 12px;
  margin-bottom: 64px;
  padding: 36px 36px 36px 24px;
  position: relative;
  background-color: white;
`;

export const ReportMapDataWrapperBody = styled(ReportDataWrapperBody)`
  padding: 36px;
`;

const ReportCardStyles = css`
  width: 100%;
  border-radius: 12px;
  background-color: #fff;
  margin: 15px 0 15px;
  padding: 25px;
`;

export const ReportCard = styled.div`
  ${ReportCardStyles}
`;

export const AnimatedReportCard = styled(ScrollAnimation)`
  ${ReportCardStyles}
`;

export const ColSegInfoWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  padding: 20px 0;
  margin-top: 40px;
`;

const ColSegInfoSC = styled.div`
  width: 25%;
  text-align: center;
  margin: 40px 0;
  > div {
    margin-bottom: 3px;
  }
  .color-dot {
    background-color: ${(props: IColSegInfoSC) => props.dotColor};
    width: 2vw;
    height: 2vw;
    min-height: 21px;
    max-height: 26px;
    min-width: 21px;
    max-width: 26px;
    border-radius: 50%;
    margin: 0 auto;
    ${device.desktop} {
      margin: 0 7px 0 0;
    }
  }
  .title {
    font-size: 13px;
    line-height: 18px;
    font-weight: 800;
    ${device.desktop} {
      font-size: 17px;
    }
    > span {
      display: block;
      ${device.desktop} {
        display: inline;
      }
    }
  }
  p {
    font-size: 11px;
    line-height: normal;
    margin-bottom: 0;
    ${device.desktop} {
      font-size: 13px;
    }
  }
  ${device.desktop} {
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ColSegInfo: FunctionComponent<IColSegInfo> = (
    props: IColSegInfo
) => {
    return (
        <ColSegInfoSC dotColor={props.dotColor}>
            <div>
                <div className="color-dot"></div>
                <div className="title">{props.title}</div>
            </div>
            <p>{props.text}</p>
        </ColSegInfoSC>
    );
};
